var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"homepage-bg"},[_c('the-app-bar'),_c('v-main',{staticClass:"v-main-custom"},[_c('v-container',{staticClass:"fill-height align-start"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }